import { useModuleContext } from "./lib/context/module-context";
import "./App.css";
import { ProgressBar } from "./components/progress-bar/";
import { ModuleRenderer } from "./components/module-renderer";
import ModuleImagePreloader from "./lib/constants/modules";
import { useTranslation } from "react-i18next";
import { useRef, useEffect, useState } from "react";

const App = () => {
  const { currentModuleNumber, next, prev } = useModuleContext();
  const { t } = useTranslation(["common"]);
  const contentRef = useRef(null);
  const [hasBottomPadding, setHasBottomPadding] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      setHasBottomPadding(el.scrollHeight > window.innerHeight * 0.8);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [currentModuleNumber]);

  const handleNavigation = (e) => {
    if (
      e.target.closest("button") ||
      e.target.closest(".progress-bar-wrapper")
    ) {
      return;
    }

    const { clientX } = e;
    const { innerWidth } = window;

    if (clientX < innerWidth / 2) {
      prev();
    } else {
      next();
    }
  };

  return (
    <div className="App" onClick={handleNavigation}>
      <div className="app-container ">
        <div className="progress-bar-wrapper">
          {currentModuleNumber && (
            <div>
              <ProgressBar />
            </div>
          )}
        </div>
        {currentModuleNumber && (
          <>
            <button
              className="split left-voice-over"
              onClick={prev}
              aria-label={t("common:voice-over:back")}
            />
            <button
              className="split right-voice-over"
              onClick={next}
              aria-label={t("common:voice-over:next")}
            />
          </>
        )}
        <div className="content-wrapper content-fade-in" ref={contentRef}>
          {currentModuleNumber && (
            <div style={hasBottomPadding ? { paddingBottom: "50px" } : {}}>
              <ModuleRenderer />
              <ModuleImagePreloader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default App;
